import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { TextBox } from 'components/form/TextBox/TextBox';
import SectionContainer from 'components/Containers/SectionContainer/index';
import { TitleContainer } from 'components/Containers/TitleContainer/TitleContainer';
import Label from 'components/form/Label/Label';
import { Row } from 'components/Containers/Row/Row';
import PageLoadingMask from 'components/masks/PageLoadingMask';
import './AccountSettings.style.scss';
import {
  TerminateAccountModal,
  AccountSuccessfullyTerminatedModal,
} from './TerminateAccountModal/TerminateAccountModal';
import { ProfileDataItem } from 'pages/Profile/components/ProfileDataItem/ProfileDataItem';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import { getViewModuleTrackingAttributes } from 'helpers/tracking.helpers';
import EmailUpdateAlert from 'partial/EmailUpdateAlert';
import {
  LOGIN_AND_SECURITY,
  TERMINATE_ACCOUNT,
} from 'types/morph.pagePosition.constants';
import { useViewModule } from 'hook/helper.hook';
import { ACCOUNT_SETTINGS } from 'types/mrph.pageName.constants';
import SecuritySection from 'pages/Profile/pages/AccountSettings/components/SecuritySection';
import { useDispatch } from 'react-redux';
import { requireTwoFactorAuthentication } from 'actions/twofactor.actions';
import { CLICK } from 'externals/_tracking/types/eventTypes.constants';
import { PasswordValidationField } from 'components/Password/PasswordValidationField/PasswordValidationField';
import { UPDATE_EMAIL } from 'partial/TwoFactorModal/TwoFactorsView.constants';
import { SET_TWO_FACTOR_STEP } from 'types/twofactors.constants';
import OText from 'components/CText/OText';

const TerminateAccount = ({ handleTerminateAccountModal, ...props }) => {
  return (
    <Row>
      <FlexContainer className="justify-end mobile-justify-center align-items-center terminateAccountLink">
        <Label
          color="secondary_text_light"
          className="bold pointer text-center width100"
          onClick={handleTerminateAccountModal}
        >
          Delete Account
        </Label>
      </FlexContainer>
      <Label type="header-description">
        <OText
          text={props?.config?.disclaimers?.terminateAccount?.initialViewLabel}
        />
      </Label>
    </Row>
  );
};
export const CollapsibleUpdateSection = function ({
  type,
  isExpanded,
  handleToggle,
  newValue,
  onValueUpdate,
  valueError,
  passwordValue,
  onPasswordInputUpdate,
  disabled,
  email,
  newEmail,
  emailPassword,
  currentPassword,
  newPassword,
  addNotification,
  updateEmail,
  updatePassword,
  toggleFocus,
  passwordFocused,
  confirmEmail,
  confirmEmailError,
  onConfirmEmailUpdate,
  profileEmail,
  hasUpdatedEmail,
  ...props
}) {
  let placeholder = 'Email Address';
  let passwordPlaceholder = 'Current Password';
  let textBoxType = null;
  const displayValue = type === 'Email' ? profileEmail : '******';
  const showEmailUpdateAlert = type === 'Email' && hasUpdatedEmail;

  const { Title, DisplayView, EditView } = ProfileDataItem;

  const passwordType = type === 'Password';
  if (passwordType) {
    placeholder = 'Current Password';
    textBoxType = 'password';
    passwordPlaceholder = 'New Password';
  }
  const handleSubmit = e => {
    e.preventDefault();
    if (type === 'Email') {
      updateEmail(
        newEmail,
        emailPassword,
        email,
        addNotification,
        confirmEmail,
      );
    } else if (type === 'Password') {
      updatePassword(currentPassword, newPassword, addNotification);
    }
  };

  let profileDataItemClass = props.classNameOverwrites?.profileDataItem;
  return (
    <ProfileDataItem
      datatestid={`accountSettings-${type}`}
      classNameOverwrites={profileDataItemClass?.profileDataItem}
    >
      <Title labelType={profileDataItemClass?.title}>{type}</Title>
      {!isExpanded && (
        <DisplayView
          datatestid={`displayView${type}`}
          editEnabled={props.editEnabled}
          editHandle={handleToggle}
          classNameOverwrites={props.classNameOverwrites?.displayView}
        >
          <Label datatestid={`readOnly${type}`}>{displayValue}</Label>
          {showEmailUpdateAlert && <EmailUpdateAlert />}
        </DisplayView>
      )}
      {isExpanded && (
        <EditView
          datatestid={`editView${type}`}
          onCancelHandle={handleToggle}
          onSaveHandle={handleSubmit}
          disabled={disabled}
          customButtonText={`Update ${type}`}
        >
          <TextBox
            type={textBoxType}
            data-testid="loginSecurityEmailInput"
            value={newValue}
            onChange={e => onValueUpdate(e)}
            placeholder={placeholder}
            error={valueError ? valueError : null}
            outerClassName={'widthToInput'}
          />
          <div className="padB16" />
          {type === 'Email' && (
            <>
              <TextBox
                type={textBoxType}
                data-testid="loginSecurityEmailInput-confirm"
                value={confirmEmail}
                onChange={e => onConfirmEmailUpdate(e)}
                placeholder="Confirm Email"
                error={confirmEmailError ? confirmEmailError : null}
                outerClassName={'widthToInput'}
              />
              <div className="padB16" />
            </>
          )}
          <div className="loginSecurityOldPass widthToInput">
            <PasswordValidationField
              datatestid={'changePassword'}
              placeholder={passwordPlaceholder}
              password={newPassword}
              passwordFocused={passwordFocused}
              onChange={e => onPasswordInputUpdate(e)}
              onFocus={toggleFocus ? toggleFocus : null}
              onBlur={toggleFocus ? toggleFocus : null}
              positionRelative
              showPreviousPasswordWarning
            />
            <div className="padB16" />
          </div>
        </EditView>
      )}
    </ProfileDataItem>
  );
};

export const AccountSettingsDefaultView = ({
  emailState,
  email,
  confirmEmail,
  emailPasswordState,
  currentPasswordState,
  newPasswordState,
  onEmailUpdate,
  onConfirmEmailUpdate,
  onEmailPasswordUpdate,
  onPasswordUpdate,
  onNewPasswordUpdate,
  submitState,
  addNotification,
  updateEmail,
  updatePassword,
  showTerminateAccountModal,
  handleTerminateAccountModal,
  sesameCashEnrolledView,
  isPremiumUser,
  ssn,
  setSsn,
  handleTerminateAccount,
  terminateAccountError,
  handleTerminateAccountSupportClick,
  emailEditEnabled,
  passwordEditEnabled,
  hasUpdatedEmail,
  showAccountSuccessfullyTerminatedModal,
  handleAccountSuccessfullyTerminated,
  showTerminateAccountContactSupport,
  handleShowTerminateAccountContactSupport,
  showDeactivatePremium,
  handleShowManageMyPremiumPlan,
  isCancelDeleteFlowWebFlagEnabled,
  ...props
}) => {
  const [emailExpanded, setEmailExpandedInternal] = useState(false);
  const [passwordExpanded, setPasswordExpandedInternal] = useState(false);
  const dispatch = useDispatch();
  const history = useHistory();
  const add2FA = (func, requireEnrollment, clickType, funcIdentifier) => v => {
    props.eventHandler(CLICK, {
      'Click Type': `2FA Check: ${clickType}`,
    });
    dispatch(
      requireTwoFactorAuthentication(props.history, props.location, {
        requireEnrollment,
      }),
    ).then(_ => {
      if (funcIdentifier === 'setEmailExpanded') {
        dispatch({
          type: SET_TWO_FACTOR_STEP,
          step: UPDATE_EMAIL,
        });
        history.push('/profile/accountSettings/2fa');
      } else {
        func(v);
      }
    });
  };
  const setPasswordExpanded = val => {
    props.eventHandler(CLICK, {
      'Click Type': 'Edit Password Click',
    });
    if (val === false) {
      const emptyObject = {
        target: {
          value: '',
        },
      };
      onNewPasswordUpdate(emptyObject);
      onPasswordUpdate(emptyObject);
    }
    setPasswordExpandedInternal(val);
  };
  const setEmailExpanded = val => {
    props.eventHandler(CLICK, {
      'Click Type': 'Edit Email Click',
    });
    if (val === false) {
      const emptyObject = {
        target: {
          value: '',
        },
      };
      onEmailUpdate(emptyObject);
      onConfirmEmailUpdate(emptyObject);
      onEmailPasswordUpdate(emptyObject);
    }
    setEmailExpandedInternal(val);
  };

  const setEmailExpandedWith2FA = add2FA(
    setEmailExpanded,
    true,
    'Edit Email Click',
    'setEmailExpanded',
  );
  const setPasswordExpandedWith2FA = add2FA(
    setPasswordExpanded,
    false,
    'Edit Password Click',
    'setPasswordExpanded',
  );
  const [passwordFocused, setPasswordFocused] = useState(false);
  const handleToggleEmail = () => {
    setEmailExpandedWith2FA(!emailExpanded);
  };
  const handleTogglePassword = () => {
    setPasswordExpandedWith2FA(!passwordExpanded);
  };
  const toggleFocus = () => {
    setPasswordFocused(!passwordFocused);
  };
  useViewModule(
    getViewModuleTrackingAttributes(
      LOGIN_AND_SECURITY,
      1,
      null,
      ACCOUNT_SETTINGS,
    ),
  );
  useViewModule(
    getViewModuleTrackingAttributes(
      TERMINATE_ACCOUNT,
      2,
      null,
      ACCOUNT_SETTINGS,
    ),
  );

  return (
    <div className="loginInformationContainer">
      <SectionContainer className="emailPasswordSection">
        <Row>
          <TitleContainer
            className="loginSecurityTitle"
            data-testid="loginSecurityTitle"
          >
            <Label type="H3" typeHeader={'h2'}>
              Login
            </Label>
          </TitleContainer>
          <CollapsibleUpdateSection
            type="Email"
            newValue={emailState.newEmail}
            onValueUpdate={onEmailUpdate}
            error={emailState.emailError}
            isExpanded={emailExpanded}
            handleToggle={handleToggleEmail}
            onPasswordInputUpdate={onEmailPasswordUpdate}
            passwordValue={emailPasswordState.emailPassword}
            disabled={submitState.emailButtonDisabled}
            newEmail={emailState.newEmail}
            emailPassword={emailPasswordState.emailPassword}
            currentPassword={currentPasswordState.password}
            newPassword={newPasswordState.newPassword}
            addNotification={addNotification}
            updateEmail={updateEmail}
            updatePassword={updatePassword}
            confirmEmail={confirmEmail.confirmEmail}
            confirmEmailError={confirmEmail.error}
            onConfirmEmailUpdate={onConfirmEmailUpdate}
            editEnabled={emailEditEnabled}
            profileEmail={email}
            hasUpdatedEmail={hasUpdatedEmail}
          />
          <CollapsibleUpdateSection
            type="Password"
            newValue={currentPasswordState.password}
            onValueUpdate={onPasswordUpdate}
            error={currentPasswordState.passwordError}
            isExpanded={passwordExpanded}
            handleToggle={handleTogglePassword}
            passwordValue={newPasswordState.newPassword}
            onPasswordInputUpdate={onNewPasswordUpdate}
            disabled={submitState.passwordButtonDisabled}
            email={emailState.email}
            newEmail={emailState.newEmail}
            emailPassword={emailPasswordState.emailPassword}
            currentPassword={currentPasswordState.password}
            newPassword={newPasswordState.newPassword}
            addNotification={addNotification}
            updateEmail={updateEmail}
            updatePassword={updatePassword}
            toggleFocus={toggleFocus}
            passwordFocused={passwordFocused}
            editEnabled={passwordEditEnabled}
          />
        </Row>
      </SectionContainer>
      {!props.config?.twofactor?.hide_enable_section && (
        <SecuritySection {...props.twoFactorSettings} />
      )}
      {!isCancelDeleteFlowWebFlagEnabled &&
        props?.config?.deleteAccount
          ?.showTerminateAccountModalAccountSettingsPage && (
          <>
            <SectionContainer className="bgTransparent flex-column">
              <TerminateAccount
                config={props.config}
                handleTerminateAccountModal={handleTerminateAccountModal}
                terminateAccountError={terminateAccountError}
              />
            </SectionContainer>
            <TerminateAccountModal
              handleTerminateAccount={handleTerminateAccount}
              handleTerminateAccountModal={handleTerminateAccountModal}
              showTerminateAccountModal={showTerminateAccountModal}
              sesameCashEnrolledView={sesameCashEnrolledView}
              isPremiumUser={isPremiumUser}
              ssn={ssn}
              setSsn={setSsn}
              terminateAccountError={terminateAccountError}
              handleTerminateAccountSupportClick={
                handleTerminateAccountSupportClick
              }
              showTerminateAccountContactSupport={
                showTerminateAccountContactSupport
              }
              handleShowTerminateAccountContactSupport={
                handleShowTerminateAccountContactSupport
              }
              handleShowManageMyPremiumPlan={handleShowManageMyPremiumPlan}
              showDeactivatePremium={showDeactivatePremium}
              planName={props?.userInfo?.premiumPlanInfo?.uiDisplayName}
              changeToTULabels={props?.config?.plusLaunch?.changeToTULabels}
            />
            <AccountSuccessfullyTerminatedModal
              showAccountSuccessfullyTerminatedModal={
                showAccountSuccessfullyTerminatedModal
              }
              handleAccountSuccessfullyTerminated={
                handleAccountSuccessfullyTerminated
              }
              showTerminateAccountContactSupport={
                showTerminateAccountContactSupport
              }
              handleShowTerminateAccountContactSupport={
                handleShowTerminateAccountContactSupport
              }
              handleShowManageMyPremiumPlan={handleShowManageMyPremiumPlan}
              showDeactivatePremium={showDeactivatePremium}
            />
          </>
        )}
    </div>
  );
};

export const AccountSettingsLoadingView = PageLoadingMask;
